
import calloutHelper from '../../../components/Callout/calloutHelper.es';
import calloutActions from '../../../components/Callout/calloutActions.es';

const favoritesCalloutsRules = function rearrangeItemsCalloutRule({ context, type }) {
    const canShowCallout = calloutHelper.canShowCallout({type});

    if (canShowCallout) {
        context.executeAction(calloutActions.openCallout, {type});
        return Promise.resolve({success: true, type});
    }

    return Promise.resolve();
};

const editFolderRule = ({ context }) => {
    return favoritesCalloutsRules({ context, type: calloutHelper.CALLOUT_TYPE_EDIT_FOLDER });
};

const rearrangeItemsRule = ({ context }) => {
    return favoritesCalloutsRules({ context, type: calloutHelper.CALLOUT_TYPE_REARRANGE_ITEMS });
};

const selectItemsRule = ({ context }) => {
    return favoritesCalloutsRules({ context, type: calloutHelper.CALLOUT_TYPE_SELECT_ITEMS });
};

export default {
    editFolderRule,
    rearrangeItemsRule,
    selectItemsRule
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/favoritesCalloutsRules.es.js